import type { Locale } from '@/i18n';

/**
 * Map a restaurant's ISO-3166 alpha-2 country to the storefront's default
 * locale: German-speaking (DE/AT/CH) → `de`, PL → `pl`, VN → `vi`, everything
 * else → `en`. Mirrors the storefront's own `countryToLocale`
 * (`apps/restaurant-storefront/lib/i18n/locale.ts`) so a shared link's default
 * language matches what a guest lands on. The dashboard supports exactly the
 * four storefront locales, so any mapped value is always a valid `Locale`.
 */
export function countryToLocale(country: string | null | undefined): Locale {
  const byCountry: Record<string, Locale> = {
    DE: 'de',
    AT: 'de',
    CH: 'de',
    PL: 'pl',
    VN: 'vi',
  };
  return country ? (byCountry[country.toUpperCase()] ?? 'en') : 'en';
}
